import NextLink from "next/link";
import { type ComponentProps } from "react";

const Link = (props: ComponentProps<typeof NextLink>) => <NextLink {...props} />;

export default Link;
